import type { IconSvgObject } from './types';

const SpeechToTextIcon: IconSvgObject = [
  ["path", { d: "M16 17H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 3.77778V8.22222M5 2V10M2 4.66667V7.33333M11 4.66667V7.33333", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H7C5.34315 22 4 20.6569 4 19V13.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default SpeechToTextIcon;
